/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, NgZone} from '@angular/core';
import * as _ from 'lodash';
import {FolioResource} from '../../components/api/resources/resource/folio.resource';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {AppEventBusService} from '../common/events/app-event-bus.service';

@Component({
  standalone: false,
  selector: 'adn-folio-list-object-states',
  template: `
    <div class="btn-group">
      <button type="button" [disabled]="currentInclude() === 'ACTIVE'" class="btn btn-default btn-xs" (click)="bulkAction('ACTIVE')">
        <span class="fa fa-power-off"></span>Activate
      </button>
      <button type="button" [disabled]="currentInclude() === 'INACTIVE'" class="btn btn-default btn-xs" (click)="bulkAction('INACTIVE')">
        <span class="fa fa-briefcase"></span>Archive
      </button>
      <button *ngIf="!hideHidden" type="button" [disabled]="currentInclude() === 'HIDDEN'" class="btn btn-default btn-xs" (click)="bulkAction('HIDDEN')">
        <span class="fa fa-trash"></span>Delete
      </button>
    </div>
  `
})
export class FolioListObjectStatesComponent {
  @Input() list: any;

  hideHidden = false;

  constructor(
    @Inject(FolioResource) private readonly folio: any,
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    private readonly eventBus: AppEventBusService,
    private readonly ngZone: NgZone
  ) {
    this.hideHidden = LocalNetworkProfile.isPureMarketplacePlatform();
  }

  currentInclude(): string {
    return this.list?.include || this.list?.showingInclude || 'ACTIVE';
  }

  bulkAction(action: string): void {
    if (!this.list?.bulkSelection || !_.size(this.list.bulkSelection)) {
      return;
    }

    const items = _.map(this.list.bulkSelection, (item: any) => ({
      id: item.id,
      objectState: action
    }));

    this.folio.bulkSave({}, items).$promise.then(() => {
      this.ngZone.run(() => {
        if (_.isFunction(this.list.makeQuery)) {
          this.list.makeQuery();
        }
        this.list.bulkSelection = {};
        if (_.isFunction(this.list.deselectAll)) {
          this.list.deselectAll();
        } else {
          this.list.bulkSelectSize = 0;
          this.list.bulkSelectState = 'empty';
        }
        this.eventBus.runAsync();
      });
    }, () => {
      this.ngZone.run(() => {
        this.eventBus.runAsync();
      });
    });
  }
}
